module.exports = __webpack_public_path__ + "static/media/6.1df9fbfe.png";